import { Component, OnInit, Input } from '@angular/core';
import { Travel } from 'src/app/models/travel';

@Component({
  selector: 'app-travel-card',
  templateUrl: './travel-card.component.html',
  styleUrls: ['./travel-card.component.css']
})
export class TravelCardComponent implements OnInit {

  @Input() travel:Travel;

  constructor() { }

  ngOnInit() {
  }

}
